import classNames from 'classnames';
import './box.scss';
import Pictogram, { PictogramType } from '../pictogram/Pictogram';

interface BoxProps {
  title: string;
  className?: string;
  children: React.ReactNode;
  boxPicture?: PictogramType;
}

const Box = ({ title, className, children, boxPicture }: BoxProps) => {
  return (
    <article
      className={classNames({
        'm-box o-flex--ai-center u-text-center u-mbs-3': true,
        className,
      })}
    >
      {boxPicture && (
        <Pictogram pictogramType={boxPicture} className="m-box__picture" />
      )}

      <h3 className="u-h4">{title}</h3>
      <div className="m-box__content m-rt">{children}</div>
    </article>
  );
};

export default Box;
